export default function() {
  const widgetName = 'cardWidgetMoreBigE';
  const widgetOpts = cardWidgetMoreBigEOpts;

  const mobileSize = 1100;
  
  let windowSize = $(window).width();

  function removeLinkMobile(data, cards) {
   
    cards.each(function (index, element) {
      const widgetData = data.items[index];
      if (windowSize < mobileSize && widgetData.URL === null) {
        $(element).removeAttr('href');
        $(element).removeAttr('target');
      }
    });
  }

  function formatTitle(data, cards) {
    const items = data.items;
    cards.each(function (index, element) {
      const title = items[index].Title;
      const titleText = title.trim();
      const titleElement = $(element).find('.card-widget-title');
      if(titleText.length >= 30) {
        const titleFormated = titleText.substring(0, 30) + '...';
        titleElement.text(titleFormated);
        titleElement.attr('title', title);
      }
  })}
  

  function exceptionsLayout(data, cards) {
    const items = data.items;
    cards.each(function (index, element) {
      const description = items[index].Description;
      const link = items[index].URL;
      
      if ( !description) {
        $(element).find('.card-widget-description').remove();
      }
      if (!link) {
        $(element).find('.buttonwrap').remove();
        
      }
      if (!description && !link) {
        $(element).addClass('no-link');
      }

    });
  }
  
  function modifyCardLayout(data, cards) {
    formatTitle(data, cards);
    exceptionsLayout(data, cards);
    removeLinkMobile(data, cards);
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'Buy Now'
    },
    cardWidgetLoaded: function(data) {
        
    const cards = $(`#${widgetName} .card-widget-item`);
      modifyCardLayout(data, cards);
     $('.moreButton').addClass('button');
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: windowSize < mobileSize ? ['all'] : [''],
    maxItemsVisible: 8,
    moreButton: {
      visible: true,
      text: 'More'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true
  });

}